import { render, staticRenderFns } from "./ModalDatingStatusInfo.vue?vue&type=template&id=6a0da09a&"
import script from "./ModalDatingStatusInfo.vue?vue&type=script&lang=js&"
export * from "./ModalDatingStatusInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports